import { call, put, select, takeLeading } from 'typed-redux-saga'
import { trustApi, TrustModel, TrustNS, trustSelector, trustSlice } from 'Pages/ibro'
import { Deserialize } from 'cerialize'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'

function* createOne(action: TrustNS.CreateOne) {
	try {
		const { data, callback } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(trustApi.createOne, data)
		yield* put(
			trustSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
				callback,
			})
		)
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* getAll(action: TrustNS.GetAll) {
	try {
		const { params, callback, clear } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		const res = yield* call(trustApi.getAll, params)
		const items = yield* select(trustSelector.selectAll)
		if (clear) res.entries = res.entries.map((item) => Deserialize(item, TrustModel))
		else
			res.entries = [...items.entries, ...res.entries.map((item) => Deserialize(item, TrustModel))]
		yield* put(trustSlice.actions.setRequestParams(params))
		yield* put(trustSlice.actions.setAll(res))
		callback?.()
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* deleteOne(action: TrustNS.DeleteOne) {
	try {
		const { id, callback } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(trustApi.deleteOne, id)
		yield* put(
			trustSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
				callback,
			})
		)
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* updateOne(action: TrustNS.UpdateOne) {
	try {
		const { item, callback } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const updatedItem = yield* call(trustApi.updateOne, item)
		const items = yield* select(trustSelector.selectAll)
		const newItems = items.entries.map((currentItem) =>
			currentItem.id === updatedItem.id ? updatedItem : currentItem
		)
		yield* put(
			trustSlice.actions.setAll(Deserialize({ ...items, entries: newItems }, ResponseCatalog))
		)
		callback?.()
	} catch (e) {
		yield* call(errorHandler, e)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* trustSaga() {
	yield* takeLeading(trustSlice.actions.createOne.type, createOne)
	yield* takeLeading(trustSlice.actions.getAll.type, getAll)
	yield* takeLeading(trustSlice.actions.deleteOne.type, deleteOne)
	yield* takeLeading(trustSlice.actions.updateOne.type, updateOne)
}
